/*
 * @version: V1.0.0
 * @Date: 2023-10-31 10:37:04
 * @LastEditors: lzq
 * @LastEditTime: 2023-11-13 16:40:20
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\api\static\index.js
 * @Descripttion:
 */
import request from '@/utils/request'

//获取左侧即时执行结果看板信息
export function getLeftData(params) {
  return request({
    url: '/wms/order/getHomeLeft',
    method: 'get',
    params
  })
}
//获首页右侧即时关键数据信息
export function getRightData(params) {
  return request({
    url: '/wms/order/getHomeRight',
    method: 'get',
    params
  })
}
